const convertRule = (schema) => {
  if (!schema) return false;
  const response = [];
  schema.forEach((elem, index) => {
    const condition = elem.condition.toUpperCase();
    if (elem.rules) {
      const children = `(${convertRule(elem.rules)})`;
      response.push(index ? `${condition} ${children}` : children);
    } else {
      let { value } = elem;
      if (elem.type === 'datetime') value = `CONVERT(DATETIME, '${elem.value}', 104)`;
      if (elem.type === 'nvarchar') value = `'${elem.value}'`;

      const query = `${elem.field} ${elem.operator} ${value}`;
      if (elem.field) {
        response.push(index ? `${condition} ${query}` : query);
      }
    }
  });
  return response.join(' ');
};

const convert = schema => `(${convertRule(schema.rules)})`;

export default convert;
